import React from 'react'
import SharedStatusBadge from '../../shared/StatusBadge'
import { t } from '../../../i18n'

const scope = 'orders'

const VARIANTS: Record<string, string> = {
  received: 'neutral-outline',
  written_to_robot: 'neutral-filled',
  cooking: 'info-outline',
  ready_for_pickup: 'success-outline',
  picked_up: 'success-filled',
  marked_for_disposal: 'danger-soft',
  disposed: 'danger-filled',
  canceled: 'danger-soft',
  failed: 'danger-filled'
}

const humanize = (value: string | null | undefined): string => (value || '').replaceAll('_', ' ')

const StatusBadge = ({ status }: { status: string | null | undefined }) => {
  if (!status) return null

  return (
    <SharedStatusBadge
      label={t(`meal_statuses.${status}`, { scope, defaultValue: humanize(status) })}
      variant={VARIANTS[status] || 'neutral-outline'}
    />
  )
}

export default StatusBadge
